import { useRef, useEffect } from "react";
import { Mutex } from "async-mutex";

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const mutex = new Mutex();
    let id = setInterval(() => {
      mutex.runExclusive(() => {
        savedCallback.current();
      });
    }, delay);
    return () => clearInterval(id);
  }, [delay]);
};
